module.exports = __webpack_public_path__ + "static/Ryu_Douglas_resume-2efafde898b6e1c250586c7db91b7bae.pdf";